import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitDateOnly'
})
export class SplitDateOnlyPipe implements PipeTransform {

  transform(value: string) {
    console.log("SplitDateOnlyPipe  : " + value);
    return (value+"").substr(0, 10);
  }

}
